import $ from "jquery"
let i = 2;
$(function () {



	// $('.itemDot').click(function () {

	// 	var dataTab = $(this).data("tab");
	// 	$('.itemDot').removeClass('active');
	// 	$(this).addClass('active');
	// 	$('.CirItem').removeClass('active');
	// 	$('.CirItem' + dataTab).addClass('active');
	// 	i = dataTab;

	// 	$('.dotCircle').css({
	// 		"transform": "rotate(" + ((i - 1) * 120) + "deg)",
	// 		"transition": "2s"
	// 	});
	// 	$('.itemDot').css({
	// 		"transform": "rotate(" + ((i - 1) * 120) + "deg)",
	// 		"transition": "1s"
	// 	});


	// });

	setInterval(function () {
		var dataTab = $('.itemDot.active').data("tab");
		if (dataTab > 6 || i > 6) {
			dataTab = 1;
			i = 1;
		}
		$('.itemDot').removeClass('active');
		$('[data-tab="' + i + '"]').addClass('active');
		$('.CirItem').removeClass('active');
		$('.CirItem' + i).addClass('active');
		i++;


		$('.dotCircle').css({
			"transform": "rotate(" + ((i - 2) * 120) + "deg)",
			"transition": "2s"
		});

		$('.itemDot').css({
			"transform": "rotate(" + (360 - (i - 2) * 120) + "deg)",
			"transition": "2s"
		});

	}, 2000);

});



